import React, { useEffect, useRef, useState } from 'react';
import '../Dashboard/Design/Dashboard.css';
import { APIEventAndPayment } from 'src/handler/accountHandler';
import UserLoader from './UserLoader';
import { Button, Input, Table, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import EventPayment from './EventPayment';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

const Event = () => {
    const hasRun = useRef(false);
    const [section, setSection] = useState("GetEvent");
    const [loader, setLoader] = useState(true);
    const [getEvent, setGetEvent] = useState([{
        "eventId": 0,
        "eventName": "",
        "eventDescription": "",
        "locationAddress": "",
        "eventDate": "",
        "eventTime": "",
        "ticketPrice": 0,
        "eventImage": ""
    }])
    const [getEventDetail, setGetEventDetail] = useState({
        "eventId": 0,
        "eventName": "",
        "eventDescription": "",
        "locationAddress": "",
        "eventDate": "",
        "eventTime": "",
        "ticketPrice": 0,
        "eventImage": ""
    })
    const addEventFormData = new FormData();
    const GetEvent = async () => {
        addEventFormData.append("enumEventAndPayment", "1");
        var response = await APIEventAndPayment(addEventFormData);
        setGetEvent(response.data.getEventDto);
        setLoader(false);
    }

    const userProfileData = {
        appToken: "",
        userInformationId: 5,
        fullName: "",
        sponsorGrowniverseId: "",
        growniverseId: "",
        address: "",
        country: "",
        state: null,
        pincode: 0,
        userIdentityGuid: "",
        emailID: "",
        phoneNumber: "",
        emailConfirmation: true,
        packageId: 0,
        packageName: "",
        isAdmin: false,
        profileImage: "",
        registrationDate: "",
        dateOfBirth: "",
        packageRequest: false
    };
    const [userProfile, setUserProfile] = useState(userProfileData);
    useEffect(() => {
        if (!hasRun.current) {
            setLoader(true);
            const storedProfile = localStorage.getItem("userProfile");
            const userProfile = JSON.parse(storedProfile ?? "");
            setUserProfile(userProfile);
            GetEvent();
            hasRun.current = true;
        }
    }, [hasRun])

    const getEventPayment = async (eventId: number) => {
        setLoader(true);
        
        addEventFormData.append("enumEventAndPayment", "7");
        addEventFormData.append("addEventDto.eventId", eventId.toString());
        var response = await APIEventAndPayment(addEventFormData);
        if (response.data.getEventPayment) {
            if (response.data.getEventPayment.status === 1) {
                setSection("Waiting")
            }
            else if (response.data.getEventPayment.status === 2) {
                setTicketReference(response.data.getEventPayment.eventPaymentId);
                setSection("Ticket");
            }
            else if (response.data.getEventPayment.status === 3) {
                setSection("Payment");
            }
        }
        else {
            setSection("Payment")
        }
        setLoader(false);
    }

    const formatDateTime = (dateOnly, timeOnly, enumForShowData = 1) => {
        // Convert DateOnly (YYYY-MM-DD) and TimeOnly (HH:MM:SS) into a full Date object
        const dateTimeString = `${dateOnly}T${timeOnly}`;
        const date = new Date(dateTimeString);

        if (enumForShowData === 1) {
            return date.toLocaleString("en-US", {
                weekday: "long"
            });
        }
        else if (enumForShowData === 2) {
            return date.toLocaleString("en-US", {
                day: "2-digit",    // Day (e.g., 20)
                month: "long",     // Month name (e.g., May)
                year: "numeric",   // Year (e.g., 2025)
            });
        }
        else if (enumForShowData === 3) {
            return date.toLocaleString("en-US", {
                hour: "2-digit",   // Hour (e.g., 11)
                minute: "2-digit", // Minute (e.g., 02)
                hour12: true
            });
        }
        else if (enumForShowData === 4) {
            date.setMinutes(date.getMinutes() - 30);
            return date.toLocaleString("en-US", {
                hour: "2-digit",   // Hour (e.g., 11)
                minute: "2-digit", // Minute (e.g., 02)
                hour12: true
            });
        }
        return date.toLocaleString("en-US", {
            weekday: "long",  // Day name (e.g., Monday)
            day: "2-digit",    // Day (e.g., 20)
            month: "long",     // Month name (e.g., May)
            year: "numeric",   // Year (e.g., 2025)
            hour: "2-digit",   // Hour (e.g., 11)
            minute: "2-digit", // Minute (e.g., 02)
            hour12: true       // AM/PM format
        });
    };

    const dayLeft = (getEventDate: string) => {
        const eventDate = new Date(getEventDate);
        eventDate.setDate(eventDate.getDate() - 1);
        const today = new Date();
        const timeDiff = eventDate.getTime() - today.getTime();
        return Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    }

    const ticketRef = useRef(null);

    const downloadPDF = () => {
        if (!ticketRef.current) {
            console.error("Reference to the ticket div is null.");
            return;
        }

        html2canvas(ticketRef.current).then((canvas) => {
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');
            pdf.addImage(imgData, 'PNG', 10, 10, 70, 0);
            pdf.save(getEventDetail.eventName + '.pdf');
        });
    };

    const [file, setFile] = useState(null);
    const [transactionId, setTransactionId] = useState(null);
    const handleFileChange = (event: any) => {
        setFile(event.target.files[0]);
    };
    const handleTrChange = (event: any) => {
        setTransactionId(event.target.value);
    };
    const [ticketReference,setTicketReference] = useState(0);

    const packagePaymentTransaction = async () => {
        setLoader(true);
        addEventFormData.append("enumEventAndPayment", "5");
        addEventFormData.append("addEventPaymentDto.userInformationId", userProfile.userInformationId.toString());
        addEventFormData.append("addEventPaymentDto.growniverseId", userProfile.growniverseId.toString());
        addEventFormData.append("addEventPaymentDto.eventId", getEventDetail.eventId.toString());
        addEventFormData.append("addEventPaymentDto.payment", getEventDetail.ticketPrice.toString());
        if (!transactionId) {
            alert('Please select a file before submitting.');
            setLoader(false);
            return;
        }
        addEventFormData.append("addEventPaymentDto.transactionId", transactionId);
        if (!file) {
            alert('Please select a file before submitting.');
            setLoader(false);
            return;
        }
        addEventFormData.append('addEventPaymentDto.imageData', file);
        var response = await APIEventAndPayment(addEventFormData);
        if (response.data.getEventPayment) {
            if (response.data.getEventPayment.status === 1) {
                setSection("Waiting")
            }
            else if (response.data.getEventPayment.status === 2) {
                setTicketReference(response.data.getEventPayment.eventPaymentId);
                setSection("Ticket");
            }
            else if (response.data.getEventPayment.status === 3) {
                setSection("Payment");
            }
        }
        else {
            setSection("Payment")
        }
        setLoader(false);
    }

    return (
        <>
            {
                loader ?
                    <>
                        <UserLoader />
                    </> : <>
                        <section className='headerBackground'>
                            {
                                section === "GetEvent"
                                    ?
                                    <>
                                        <div className='p-5'>
                                            {
                                                getEvent.map((data) => (
                                                    <>
                                                        <div style={{
                                                            padding: "25px",
                                                            maxWidth: "600px",
                                                            margin: "auto",
                                                            background: "linear-gradient(135deg, #f5f5f5, #e3e3e3)",
                                                            border: "1px solid #ccc",
                                                            borderRadius: "14px",
                                                            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)"
                                                        }} className='d-flex flex-column align-items-center p-4 headerBackgroundReverse'>

                                                            <div style={{ marginBottom: "20px" }}>
                                                                <img className='eventShow' src={`data:image/jpeg;base64,${data.eventImage}`} alt="Event Image"
                                                                    style={{
                                                                        borderRadius: "12px",
                                                                        boxShadow: "0px 6px 12px rgba(0,0,0,0.15)",
                                                                        border: "4px solid #fff"
                                                                    }} />
                                                            </div>

                                                            <div className='text-center'>
                                                                <h2 style={{ fontWeight: "800", color: "#222", marginBottom: "10px", fontSize: "24px" }}>{data.eventName}</h2>
                                                                <p style={{ color: "#444", fontSize: "18px", lineHeight: "1.8", fontWeight: "500" }}>
                                                                    <strong>Day:</strong> {formatDateTime(data.eventDate, data.eventTime, 1)} <br />
                                                                    <strong>Date:</strong> {formatDateTime(data.eventDate, data.eventTime, 2)} <br />
                                                                    <strong>Entry Time:</strong> {formatDateTime(data.eventDate, data.eventTime, 4)} <br />
                                                                    <strong>Meeting Time:</strong> {formatDateTime(data.eventDate, data.eventTime, 3)} <br />
                                                                    {/* <div style={{
                                                                        background: "linear-gradient(45deg, #2ecc71, #27ae60)",
                                                                        color: "white",
                                                                        fontSize: "22px",
                                                                        fontWeight: "bold",
                                                                        padding: "12px",
                                                                        borderRadius: "10px",
                                                                        textAlign: "center",
                                                                        boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
                                                                        letterSpacing: "1px",
                                                                        maxWidth: "300px"
                                                                    }}>
                                                                        🎟 Ticket Price: ₹{data.ticketPrice}
                                                                    </div> */}

                                                                    <div className='headerBackgroundReverse color-white' style={{ marginTop: "10px" }}>
                                                                        <i className="fa-solid fa-clock"></i> {dayLeft(data.eventDate)} days Left
                                                                    </div>
                                                                    <Button style={{
                                                                        background: "linear-gradient(135deg, #000000, #434343)",
                                                                        color: "#fff",
                                                                        fontSize: "20px",
                                                                        fontWeight: "bold",
                                                                        padding: "14px 24px",
                                                                        borderRadius: "8px",
                                                                        border: "none",
                                                                        cursor: "pointer",
                                                                        transition: "all 0.3s ease",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: "center",
                                                                        minWidth: "280px",
                                                                        boxShadow: "0px 4px 8px rgba(0,0,0,0.3)",
                                                                        marginTop: "10px"
                                                                    }}
                                                                        onClick={() => {
                                                                            setGetEventDetail(data);
                                                                            getEventPayment(data.eventId);
                                                                        }}
                                                                    >
                                                                        🎟 Get Ticket
                                                                    </Button>
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <hr style={{
                                                            border: "none",
                                                            height: "10px",
                                                            backgroundColor: "black",
                                                            width: "100%",
                                                            margin: "20px 0"
                                                        }} />

                                                    </>
                                                ))
                                            }
                                        </div>
                                    </>
                                    :
                                    section === "Payment"
                                        ?
                                        <>
                                            <Button style={{ background: "black" }} className="btn btn-primary p-3 color-white" onClick={() => { setSection("GetEvent") }}>Back</Button>
                                            <div style={{
                                                background: "#fafafa",
                                                padding: "40px",
                                                border: "1px solid #ddd",
                                                fontFamily: "'Times New Roman', serif",
                                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
                                            }}>
                                                <TableContainer style={{
                                                    background: "#ffffff",
                                                    padding: "25px",
                                                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)"
                                                }}>
                                                    <h3 style={{
                                                        background: "#003b46",
                                                        color: "#ffffff",
                                                        textAlign: "center",
                                                        padding: "15px",
                                                        fontSize: "20px",
                                                        fontWeight: "700",
                                                        letterSpacing: "1px",
                                                        textTransform: "uppercase"
                                                    }}>
                                                        Billing Details
                                                    </h3>
                                                    <Table style={{ marginTop: "10px" }}>
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell align="left" style={{
                                                                    fontWeight: "600",
                                                                    fontSize: "16px",
                                                                    color: "#333",
                                                                    borderBottom: "2px solid #ddd"
                                                                }}>Ticket Price</TableCell>
                                                                <TableCell align="right" style={{
                                                                    fontWeight: "700",
                                                                    fontSize: "20px",
                                                                    color: "green",
                                                                    borderBottom: "2px solid #ddd"
                                                                }}>₹{getEventDetail.ticketPrice}</TableCell>
                                                            </TableRow>
                                                        </TableHead>
                                                    </Table>
                                                </TableContainer>
                                            </div>
                                            <div className="row d-flex justify-content-center headerBackgroundReverse" style={{
                                                background: "",
                                                borderColor: "white",
                                                borderStyle: "inset",
                                                borderRadius: "10px",
                                                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                                            }}>
                                                <div className={"header col-10 headerBackground"} style={{
                                                    background: "", textAlign: "center", padding: "20px", marginBottom: "10px",
                                                }}>
                                                    <h3 style={{ background: "#228B22", color: "#D3D3D3", marginTop: "10px" }}>
                                                        UPI ID - teamgrowniverse@axl
                                                    </h3>
                                                    <div className="header" style={{ height: "100px", background: "white", padding: "10px" }}>
                                                        <Input name='imageFileData' type="file" onChange={handleFileChange} required />
                                                        <h4> <Input name='transactionId' style={{ color: "black" }} placeholder="Enter Transaction Id" onChange={handleTrChange} required /></h4>
                                                        <Button variant="contained" style={{ background: "#fa9602" }} onClick={packagePaymentTransaction}>
                                                            Submit
                                                        </Button>
                                                    </div><br /><br />
                                                </div>
                                            </div>
                                        </>
                                        :
                                        section === "Ticket"
                                            ?
                                            <>
                                                <div className='p-4 d-flex flex-column align-items-center'>
                                                    <div ref={ticketRef} className='p-4 d-flex flex-column align-items-center' style={{ background: 'linear-gradient(135deg, #6e8efb, #a777e3)', borderRadius: '12px', padding: '20px', boxShadow: '0px 8px 16px rgba(0,0,0,0.3)', maxWidth: '500px' }}>
                                                        <div className='bg-white text-center' style={{ padding: '20px', borderRadius: '12px', boxShadow: '0px 6px 12px rgba(0,0,0,0.2)' }}>
                                                            <img
                                                                className='eventShow'
                                                                src={`data:image/jpeg;base64,${getEventDetail.eventImage}`}
                                                                alt="Event Image"
                                                                style={{
                                                                    borderRadius: "12px",
                                                                    boxShadow: "0px 6px 12px rgba(0,0,0,0.15)",
                                                                    border: "6px solid #fff",
                                                                    width: '100%',
                                                                    maxWidth: '400px'
                                                                }}
                                                            />
                                                            <div style={{
                                                                marginTop: '20px',
                                                                padding: '20px',
                                                                textAlign: 'center',
                                                                background: 'linear-gradient(135deg, #f3f3f3, #ffffff)',
                                                                borderRadius: '12px',
                                                                boxShadow: '0px 4px 8px rgba(0,0,0,0.2)',
                                                                maxWidth: '500px'
                                                            }}>
                                                                <h2 style={{ fontSize: "24px", fontWeight: "bold", color: "#2D2D2D", textTransform: "uppercase", letterSpacing: "1px" }}>
                                                                    {getEventDetail.eventName}
                                                                </h2>

                                                                <p style={{ fontSize: "18px", color: "#555", fontWeight: "500", marginTop: '12px', lineHeight: '1.5' }}>
                                                                    <strong style={{ color: "black" }}>{userProfile.fullName} ({userProfile.growniverseId})</strong><br />
                                                                    We are thrilled to have you at <br /><strong>{getEventDetail.eventName}</strong>.
                                                                </p>

                                                                <div style={{
                                                                    marginTop: '15px',
                                                                    fontSize: "16px",
                                                                    color: "#333",
                                                                    fontWeight: "500",
                                                                    padding: "15px",
                                                                    background: "#e3e3e3",
                                                                    borderRadius: "8px",
                                                                    boxShadow: "inset 0px 2px 4px rgba(0,0,0,0.1)"
                                                                }}>
                                                                    📅 <strong>{formatDateTime(getEventDetail.eventDate, getEventDetail.eventTime, 1)}</strong> <br />
                                                                    📆 <strong>{formatDateTime(getEventDetail.eventDate, getEventDetail.eventTime, 2)}</strong> <br />
                                                                    ⏰ <strong>{formatDateTime(getEventDetail.eventDate, getEventDetail.eventTime, 3)}</strong> <br />
                                                                    📍 <strong>{getEventDetail.locationAddress}</strong>
                                                                </div>
                                                            </div>

                                                            <div className='headerBackground' style={{ marginTop: '20px', padding: '10px', borderRadius: '8px', color: '#fff', fontWeight: 'bold', fontSize: '18px' }}>
                                                                🎟 Your Exclusive Pass!
                                                            </div>
                                                            <div style={{ marginTop: '15px', fontSize: "20px", color: "black", fontWeight: "bold", textAlign: "center" }}>
                                                                Ticket Reference No: E1065{ticketReference}<strong></strong>
                                                            </div>

                                                        </div>
                                                    </div>
                                                    <Button style={{ background: "black" }} className="btn btn-primary p-3 color-white" onClick={() => { setSection("GetEvent") }}>Back</Button>
                                                    <Button onClick={downloadPDF} style={{ marginTop: '20px', padding: '10px', fontSize: '16px', background: '#007BFF', color: '#fff', border: 'none', borderRadius: '8px' }}>
                                                        📥 Download Ticket as PDF
                                                    </Button>
                                                </div>
                                            </>
                                            :
                                            <>
                                                {
                                                    section === "Waiting" ?
                                                        <>
                                                            <div style={{
                                                                background: "#f8f9fa",
                                                                color: "#2D2D2D",
                                                                fontSize: "18px",
                                                                fontWeight: "600",
                                                                padding: "15px",
                                                                borderRadius: "8px",
                                                                textAlign: "center",
                                                                boxShadow: "0px 4px 8px rgba(0,0,0,0.2)",
                                                                maxWidth: "400px",
                                                                margin: "auto",
                                                            }}>
                                                                ⏳ Your Ticket Confirmation is Pending...<br />
                                                                🔍 We are Waiting to Confirm your place in Our Event.
                                                            </div>
                                                            <Button style={{ background: "black" }} className="btn btn-primary p-3 color-white" onClick={() => { setSection("GetEvent") }}>Back</Button>
                                                        </> : <></>
                                                }
                                            </>
                            }
                        </section>
                    </>
            }
        </>
    );
};

export default Event;
